// Module
var code = "<record-form-view fields=\"stateController.formFields\" model=\"stateController.model\" title=\"Contract Edit\" on-submit=\"stateController.submit(formViewController)\" on-cancel=\"stateController.cancel(formViewController)\"></record-form-view> ";
// Exports
export default code;